import React from 'react'
import cn from 'classnames'

interface EmotionWordData {
  id: string
  name: string
  definition: string
}

interface Props {
  word: EmotionWordData
  isChosen?: boolean
  onClick: () => void
  disabled?: boolean
}

interface State {
  isEmotionWordPopupVisible: boolean
}

export default class EmotionWord extends React.Component<Props, State> {
  state: State = {
    isEmotionWordPopupVisible: false,
  }

  render() {
    const { word, isChosen } = this.props
    return (
      <div
        role="button"
        className={cn('radio clear emotion-word', {
          disabled: this.props.disabled,
          selected: isChosen,
        })}
        key={word.id}>
        <input
          id={word.id}
          name="emotion"
          type="radio"
          onChange={this.props.onClick}
          checked={isChosen}
          disabled={this.props.disabled}
        />
        <label className="text-capitalize" htmlFor={word.id}>
          <span>{word.name}</span>
          <i
            className="icon-info"
            data-toggle="emotion-word-definition"
            onMouseEnter={() => {
              this.setState({
                isEmotionWordPopupVisible: true,
              })
            }}
            onMouseLeave={() => {
              this.setState({
                isEmotionWordPopupVisible: false,
              })
            }}
            aria-label="Click to view definition"
            aria-controls="emotion-word-definition"
            data-is-focus="false"
            data-yeti-box="emotion-word-definition"
            aria-haspopup="true"
            aria-expanded="false"
          />
        </label>
        {this.state.isEmotionWordPopupVisible ? (
          <div className="emotion-word-tooltip">
            <h4>{word.name}</h4>
            <p>{word.definition}</p>
          </div>
        ) : null}
      </div>
    )
  }
}
